import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const SwitchView = ({ setDrugsView, viewName, label }) => {
  return (
    <button
      type="button"
      onClick={() => setDrugsView(viewName)}
      className="w3-btn w3-round-xlarge w3-theme-d5 responsive-button"
    >
      {label} <FontAwesomeIcon icon={faArrowRight} />
    </button>
  );
};

export default SwitchView;
